"use client";

import { Button } from "@/components/ui/button";
import PlusCircleIcon from "@heroicons/react/24/outline/PlusCircleIcon";
import { Link } from "@/components/CustomLink";
import { ROUTES } from "@/@core/constants/routes";
import { useTranslation } from "@/hooks/translationContext";

interface SidebarAddVenueButtonProps {
  onClose?: () => void;
  customClasses?: string;
  width?: string;
}

export default function SidebarAddVenueButton({
  onClose,
  customClasses,
  width,
}: SidebarAddVenueButtonProps) {
  const { t } = useTranslation();

  const handleClick = () => {
    if (onClose) {
      onClose();
    }

    return true;
  };

  const getTitle = () => {
    return t("venue-add-title", {
      defaultValue: "Mekan Ekle",
    });
  };

  return (
    <div className={width ? `w-[${width}]` : "w-full"}>
      <Link title={getTitle()} className="w-full" href={ROUTES.VENUE.CREATE}>
        <Button
          onClick={handleClick}
          variant="accent"
          className={`w-full flex justify-between ${customClasses}`}
        >
          <span>
           {getTitle()}
          </span>
          <PlusCircleIcon className="size-5" />
        </Button>
      </Link>
    </div>
  );
}
